import { couponStatusMap, cardTypeMap, couponTypeMap, sourceMap } from '@/dicts/coupon'
import { mapFilter } from './util'

export function couponStatus (value) {
  return mapFilter(value, couponStatusMap)
}

export function cardType (value) {
  return mapFilter(value, cardTypeMap)
}

export function couponType (value) {
  return mapFilter(value, couponTypeMap)
}

export function source (value) {
  return mapFilter(value, sourceMap)
}
